import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, CardTitle, Spinner } from 'reactstrap';
import { ref, query, equalTo, orderByChild, onValue, get } from 'firebase/database';
import { db } from '../../../firebase';
import ParagraphComparison from './ParagraphComparison.js';
import { useLocation } from 'react-router-dom';
import { errorToast } from '../../common/toast.js';

const ViewUserQCReports = () => {
    const { token } = useParams();
    const [submittedForms, setSubmittedForms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const location = useLocation();
    const user = location.state;

    const fetchSubmittedForms = useCallback(async () => {
        if (!token) return;
        setLoading(true);
        setError(null);

        try {
            const formsRef = ref(db, `userForms/${token}`); // Reference to a specific user's node by token
            const snapshot = await get(formsRef); // Fetch data directly by ID

            if (!snapshot.exists()) {
                setError("No reports found for the provided token.");
                setSubmittedForms([]);
                return;
            }

            const formsData = snapshot.val();

            let formsArray = [];
            Object.entries(formsData).forEach(([key, value]) => {
                if (key.startsWith('para')) {
                    formsArray.push({
                        ...value,
                        name: key,
                        id: parseInt(key.slice(4)),
                        mistakes: 0,
                    });
                }
            });

            setSubmittedForms(formsArray.sort((a, b) => a.id - b.id));
        } catch (error) {
            errorToast("Error fetching submitted forms: " + error.message);
            setError("Could not load forms. Please try again later.");
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        fetchSubmittedForms();
    }, [fetchSubmittedForms]);

    const handleMistakeCount = (formId, mistakeCount) => {
        setSubmittedForms(prevForms =>
            prevForms.map(form =>
                form.id === formId ? { ...form, mistakes: mistakeCount } : form
            )
        );
    };

    return (
        <Container className="mt-4">
            <h4>User QC Reports</h4>
            <div className='d-flex justify-content-between m-2'>
                <h5>Name:- {user?.name}</h5>
                <h5>Email:- {user?.email}</h5>
                <h5>Number:- {user?.number}</h5>
            </div>

            {loading ? (
                <div className="text-center">
                    <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                    <p>Loading reports...</p>
                </div>
            ) : error ? (
                <div className="text-center text-danger">
                    <p>{error}</p>
                </div>
            ) : (
                <Row>
                    {submittedForms.map((form) => (
                        <Col md="12" key={form.id} className="mb-4">
                            <Card>
                                <CardBody>
                                    <CardTitle tag="h5">Form {form.id}</CardTitle>
                                    <Row>
                                        <Col xs="6">
                                            <strong>Original Paragraph:</strong>
                                            <div className="no-copy-card">
                                                <p>{form.original || "No data available"}</p>
                                            </div>
                                        </Col>
                                        <Col xs="6">
                                            <ParagraphComparison
                                                original={form.original || ""}
                                                userInput={form.userInput || ""}
                                                onMistakeCount={(mistakeCount) =>
                                                    handleMistakeCount(form.id, mistakeCount)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </Container>
    );
};

export default ViewUserQCReports;
